import WebApp from '@twa-dev/sdk';

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData?: string;
      };
    };
  }
}

export function getTelegramInitData(): string | undefined {
  try {
    const live = (WebApp.initData || window?.Telegram?.WebApp?.initData || '').trim();
    if (live) {
      persistInitData(live);
      return live;
    }
    return readCachedInitData();
  } catch {
    return readCachedInitData();
  }
}

/** Ждёт появления initData (при открытии из кнопки Web App иногда приходит с задержкой). Макс. maxWaitMs мс, проверка каждые intervalMs. */
export function waitForInitData(maxWaitMs = 4000, intervalMs = 80): Promise<void> {
  return new Promise((resolve) => {
    if (getTelegramInitData()) {
      resolve();
      return;
    }
    const deadline = Date.now() + maxWaitMs;
    const t = setInterval(() => {
      if (getTelegramInitData() || Date.now() >= deadline) {
        clearInterval(t);
        resolve();
      }
    }, intervalMs);
  });
}

const INIT_DATA_CACHE_KEY = 'tg_webapp_init_data_v1';
const INIT_DATA_CACHE_TS_KEY = 'tg_webapp_init_data_ts_v1';
// Backend TTL по умолчанию 7 дней; держим меньше, чтобы не использовать почти просроченные данные.
const INIT_DATA_CACHE_TTL_MS = 6 * 24 * 60 * 60 * 1000;

function persistInitData(value: string): void {
  if (!value) return;
  const now = String(Date.now());
  try {
    sessionStorage.setItem(INIT_DATA_CACHE_KEY, value);
    sessionStorage.setItem(INIT_DATA_CACHE_TS_KEY, now);
  } catch {
    // ignore
  }
  try {
    localStorage.setItem(INIT_DATA_CACHE_KEY, value);
    localStorage.setItem(INIT_DATA_CACHE_TS_KEY, now);
  } catch {
    // ignore
  }
}

function readFromStorage(storage: Storage): string | undefined {
  try {
    const value = storage.getItem(INIT_DATA_CACHE_KEY)?.trim();
    const tsRaw = storage.getItem(INIT_DATA_CACHE_TS_KEY);
    const ts = tsRaw ? Number(tsRaw) : NaN;
    if (!value || !Number.isFinite(ts)) return undefined;
    if (Date.now() - ts > INIT_DATA_CACHE_TTL_MS) return undefined;
    return value;
  } catch {
    return undefined;
  }
}

function readCachedInitData(): string | undefined {
  const fromSession = typeof sessionStorage !== 'undefined' ? readFromStorage(sessionStorage) : undefined;
  if (fromSession) return fromSession;
  return typeof localStorage !== 'undefined' ? readFromStorage(localStorage) : undefined;
}
